import { SurveyStatus } from '@occc/graphql';

export const archivableStatuses: SurveyStatus[] = [
  SurveyStatus.Active,
  SurveyStatus.Draft,
  SurveyStatus.Expired,
];
